import { useObserver } from "mobx-react";
import React, { useContext, useState } from "react";
import { Store } from "../state/state";

function Margin_Field() {
  const store = useContext(Store);
  const [top, setTop] = useState(0);
  const [right, setRight] = useState(0);
  const [left, setLeft] = useState(0);
  const [bottom, setBottom] = useState(0);
  return (
    <div className="flex w-full items-center my-4 justify-end">
      <div className="flex items-center">
        <Box
          direction={"top"}
          onChange={(n) => {
            setTop(n);

            store.theme.images[store.select].marginTop = n + "px";
          }}
          value={top}
        />
        <Box
          direction={"right"}
          value={right}
          onChange={(n) => {
            setRight(n);
            store.theme.images[store.select].marginRight = n + "px";
          }}
        />
        <Box
          direction={"bottom"}
          value={bottom}
          onChange={(n) => {
            setBottom(n);
            store.theme.images[store.select].marginBottom = n + "px";
          }}
        />
        <Box
          direction={"left"}
          value={left}
          onChange={(n) => {
            setLeft(n);
            store.theme.images[store.select].marginLeft = n + "px";
          }}
        />
      </div>
      <div className="pt-2 flex-1 flex justify-end">
        <span className="text-right w-full text-lg">: تباعد </span>
      </div>
    </div>
  );
}
const Box = ({ value, direction, onChange }) => (
  <div className="flex items-center justify-center flex-col">
    <div
      className="w-3 h-3 border mb-2"
      style={{
        borderColor: `${direction === "top" ? "black" : "#ddd"} ${
          direction === "right" ? "black" : "#ddd"
        } ${direction === "bottom" ? "black" : "#ddd"} ${
          direction === "left" ? "black" : "#ddd"
        }`,
        borderWidth: `${direction === "top" ? "2px" : "1px"} ${
          direction === "right" ? "2px" : "1px"
        } ${direction === "bottom" ? "2px" : "1px"} ${
          direction === "left" ? "2px" : "1px"
        }`,
      }}
    ></div>
    <input
      style={{ fontFamily: "serif" }}
      type="number"
      className="border w-12 mx-2 text-center rounded shadow outline-none"
      value={value ? value : undefined}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
export default Margin_Field;
